module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.viewData.title)))]), _vm._v(" "), _vm._l((_vm.Keys), function(row) {
    return (_vm.Keys.length) ? _c('div', {
      key: row,
      staticClass: "w5-form-row"
    }, _vm._l((_vm.sortDATA[row]), function(field, idx) {
      return _c('viewComponent', {
        key: row + '_' + idx,
        attrs: {
          "data": _vm.viewData,
          "rowCount": _vm.sortDATA[row].length,
          "y": row,
          "x": idx,
          "field": field,
          "crud": _vm.crud,
          "realCrudName": _vm.realCrudName,
          "firstElement": _vm.sortDATA && _vm.sortDATA['1'] && _vm.sortDATA['1'][0] ? _vm.sortDATA['1'][0] : null,
          "objectId": _vm.id
        },
        on: {
          "needRefresh": _vm.needRefresh,
          "errorFilter": _vm.errorFilter
        }
      })
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.viewData && 'logs' in _vm.viewData && _vm.viewData['logs'] && Array.isArray(_vm.viewData['logs']) && _vm.viewData['logs'].length) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    staticClass: "w5-view-field",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h4', {
    staticClass: "w5-view-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")('logs/title')))]), _vm._v(" "), _c('table', {
    staticClass: "w5-view-field-table w5-view-field-table-logs"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/created')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm._f("ftc")('operation/comment')))]), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? _c('th', [_vm._v(_vm._s(_vm._f("ftc")('main/data')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewData['logs']), function(log, idx) {
    return _c('tr', {
      key: 'tr-' + idx
    }, [_c('td', {
      attrs: {
        "align": "center",
        "aria-label": _vm._f("ftc")('main/created')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(log.log_date && log.log_date.value ? _vm.formater_StrDateFormat(log.log_date.value) : '') + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('operation/comment')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(log.log_comment && log.log_comment.value ? log.log_comment.value : '')) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? _c('td', {
      attrs: {
        "aria-label": _vm._f("ftc")('main/data')
      }
    }, [_c('span', {
      staticClass: "w5-table-cell"
    }, [(log.log_data && log.log_data.value && String(log.log_data.value).trim() !== '') ? _c('pre', [_vm._v(_vm._s(log.log_data.value))]) : _vm._e()])]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-field"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    class: {
      hidden: _vm.form_Loading
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.backButton($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/back')))]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6728bb5d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/View.vue
// module id = 549
// module chunks = 0